import { messageService } from '@/helpers/message.service';
import { logger } from '@/helpers/log.service';

function info(message?: any, ...optionalParams: any[]): void {
  const { logToStoreResult } = logger.info(message, ...optionalParams);
  if (logToStoreResult) {
    messageService.info({
      message: logToStoreResult.message,
      storeMessageId: logToStoreResult.storeMessageId
    });
  }
}

function warn(message?: any, ...optionalParams: any[]): void {
  const { logToStoreResult } = logger.warn(message, ...optionalParams);
  if (logToStoreResult) {
    messageService.warn({
      message: logToStoreResult.message,
      storeMessageId: logToStoreResult.storeMessageId
    });
  }
}

function error(message?: any, ...optionalParams: any[]): void {
  const { logToStoreResult } = logger.error(message, ...optionalParams);
  if (logToStoreResult) {
    messageService.error({
      message: logToStoreResult.message,
      storeMessageId: logToStoreResult.storeMessageId
    });
  }
}

export const logHelper = { info, warn, error };
